import Controller from '../custom_advent_calendar_product_controller'
export default Controller
